import { render, staticRenderFns } from "./PnetMessageListSideMenu.vue?vue&type=template&id=064261c5&scoped=true"
import script from "./PnetMessageListSideMenu.vue?vue&type=script&lang=js"
export * from "./PnetMessageListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./PnetMessageListSideMenu.vue?vue&type=style&index=0&id=064261c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064261c5",
  null
  
)

export default component.exports